"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.R_Send = void 0;
var TransactionAmount_1 = require("./TransactionAmount");
var Transaction_1 = require("./Transaction");
var Bytes_1 = require("../Bytes");
var DataWriter_1 = require("../DataWriter");
var BigDecimal_1 = require("../../BigDecimal");
var TranTypes_1 = require("./TranTypes");
/* tslint:disable-next-line */
var R_Send = /** @class */ (function (_super) {
    __extends(R_Send, _super);
    function R_Send(creator, feePow, recipient, key, amount, head, data, isText, encrypted, timestamp, reference, port, genesis_sign, transferType) {
        if (transferType === void 0) { transferType = TranTypes_1.ETransferType.DEFAULT; }
        var _this = this;
        var transferFields = R_Send.transferTypeFields(transferType, key, amount);
        _this = _super.call(this, transferFields.typeBytes, R_Send.NAME_ID, creator, feePow, recipient, transferFields.amount, transferFields.assetKey, timestamp, reference, port, genesis_sign) || this;
        _this.head = head || '';
        if (data == null || data.length === 0) {
            // set version byte
            _this.typeBytes[3] = _this.typeBytes[3] | -128;
        }
        else {
            _this.data = data;
            _this.encrypted = encrypted;
            _this.isText = isText;
        }
        return _this;
    }
    R_Send.transferTypeFields = function (transferType, assetKey, amount) {
        var transferFields = {
            typeBytes: new Int8Array([
                R_Send.TYPE_ID,
                2,
                0,
                amount ? Transaction_1.Transaction.diffScale(amount.num) : 0,
            ]),
            assetKey: assetKey,
            amount: amount
        };
        if (transferType === TranTypes_1.ETransferType.DEBT) {
            // выдать в долг
            transferFields.assetKey = -1 * transferFields.assetKey;
        }
        else if (transferType === TranTypes_1.ETransferType.RETURN_DEBT) {
            // вернуть долг
            transferFields.assetKey = -1 * transferFields.assetKey;
            // BACKWARD
            // transferFields.typeBytes[2] = transferFields.typeBytes[2] | 2 | 64;
        }
        else if (transferType === TranTypes_1.ETransferType.CONFISCATE_DEBT) {
            // конфисковать долг
            transferFields.assetKey = -1 * transferFields.assetKey;
            // BACKWARD
            transferFields.typeBytes[2] = transferFields.typeBytes[2] | 64;
        }
        else if ((transferType === TranTypes_1.ETransferType.TAKE) &&
            transferFields.amount) {
            // принять на руки
            transferFields.amount = new BigDecimal_1.BigDecimal(-1 * transferFields.amount.num);
            // BACKWARD
            transferFields.typeBytes[2] = transferFields.typeBytes[2] | 64;
        }
        else if ((transferType === TranTypes_1.ETransferType.SPEND) &&
            transferFields.amount) {
            // потратить
            transferFields.amount = new BigDecimal_1.BigDecimal(-1 * transferFields.amount.num);
            transferFields.assetKey = -1 * transferFields.assetKey;
        }
        else if (transferType === TranTypes_1.ETransferType.PLEDGE && transferFields.amount) {
            // передать в залог
            // BACKWARD
            transferFields.typeBytes[2] = transferFields.typeBytes[2] | 64;
        }
        else if (transferType === TranTypes_1.ETransferType.RETURN_PLEDGE && transferFields.amount) {
            // вернуть с залога
            transferFields.amount = new BigDecimal_1.BigDecimal(-1 * transferFields.amount.num);
        }
        return transferFields;
    };
    R_Send.prototype.getDataLength = function (asPack) {
        return __awaiter(this, void 0, void 0, function () {
            var headBytes, dataLen;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.head)];
                    case 1:
                        headBytes = _a.sent();
                        return [4 /*yield*/, _super.prototype.getDataLength.call(this, asPack)];
                    case 2:
                        dataLen = (_a.sent()) + 1 + headBytes.length;
                        if (this.typeBytes[3] >= 0) {
                            return [2 /*return*/, dataLen + R_Send.BASE_LENGTH + this.data.length];
                        }
                        else {
                            return [2 /*return*/, dataLen];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    R_Send.prototype.getFee = function () {
        return this.feePow;
    };
    R_Send.prototype.getFeeBig = function () {
        return this.fee;
    };
    R_Send.prototype.toBytes = function (withSign, releaserReference) {
        return __awaiter(this, void 0, void 0, function () {
            var data, _a, _b, headBytes, dataSizeBytes;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        data = new DataWriter_1.DataWriter();
                        _b = (_a = data).set;
                        return [4 /*yield*/, _super.prototype.toBytes.call(this, withSign, releaserReference)];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        return [4 /*yield*/, Bytes_1.Bytes.stringToByteArray(this.head)];
                    case 2:
                        headBytes = _c.sent();
                        //HEAD SIZE
                        data.setNumber(headBytes.length);
                        //HEAD
                        data.set(headBytes);
                        if (!(this.data != null)) return [3 /*break*/, 4];
                        return [4 /*yield*/, Bytes_1.Bytes.intToByteArray(this.data.length)];
                    case 3:
                        dataSizeBytes = _c.sent();
                        data.set(dataSizeBytes);
                        //WRITE DATA
                        data.set(this.data);
                        //WRITE ENCRYPTED
                        data.set(this.encrypted);
                        //WRITE ISTEXT
                        data.set(this.isText);
                        _c.label = 4;
                    case 4: return [2 /*return*/, data.data];
                }
            });
        });
    };
    R_Send.BASE_LENGTH = Transaction_1.Transaction.IS_TEXT_LENGTH + Transaction_1.Transaction.ENCRYPTED_LENGTH + Transaction_1.Transaction.DATA_SIZE_LENGTH;
    R_Send.TYPE_ID = Transaction_1.Transaction.SEND_ASSET_TRANSACTION;
    R_Send.NAME_ID = 'Send';
    return R_Send;
}(TransactionAmount_1.TransactionAmount));
exports.R_Send = R_Send;
